<template>
    <div class="result-filter facet-filter">
        <h5 class="filter-title facet-type">Kategorie</h5>
        <navigation-tree :showNode="isNodeVisible" :tree="categories"></navigation-tree>
    </div>
</template>

<script>
    import NavigationTree from "@/components/NavigationTree";

    export default {
        name: "FilterFacetCategory",
        components: {NavigationTree},
        props: ['facet'],
        computed: {
            categories() {
                return this.$store.state.categories;
            }
        },
        methods: {
            isNodeVisible(node) {
                for (var type in this.facet) {
                    if (Object.prototype.hasOwnProperty.call(this.facet, type)) {
                        for (var id in this.facet[type]) {
                            if (Object.prototype.hasOwnProperty.call(this.facet[type], id)) {
                                let path = this.$store.state.categoriesMap[id];
                                let result = path.indexOf(node.id);
                                if (result >= 0)
                                    return this.facet[type][id]
                            }
                        }
                    }
                }

                return 0;

            },
            categoryName(id) {
                let path = this.$store.state.categoriesMap[id];
                let level = path.split('/');
                const categories = this.$store.state.categories;
                let current = {children: categories};
                for (let i = 1; i < level.length; i++) {
                    const levelID = level[i];
                    current = current.children.find(function (item) {
                        return parseInt(levelID) === item.id;
                    });


                }

                if (current)
                    return current.name;

                return id;
            }
        },
        created() {

        }
    }
</script>

<style scoped>

</style>
